export default __webpack_public_path__ + "static/media/device-pile.ff81d825.png";